const COLOR_PRIMARY = "#082478";
const COLOR_GRAY = "#3F425D";
const COLOR_PRIMARY_GRAY = "#5C6376";
const BG_PRIMARY_GRAY = "#EDF0F4";
const COLOR_WHITE = "#FFF";
const COLOR_COMMON_BLACK = "#223354";

export const styledCss = {
  h2: {
    fontSize: "32px",
    color: COLOR_PRIMARY,
    fontWeight: 500,
    textAlign: "center",
  },
  h3: {
    fontSize: "24px",
    color: COLOR_PRIMARY,
    fontWeight: 500,
    textAlign: "center",
  },
  h4: {
    fontSize: "16px",
    color: COLOR_GRAY,
    fontWeight: 400,
    textAlign: "center",
  },
  buttonPrimary: {
    backgroundColor: COLOR_PRIMARY,
    color: COLOR_WHITE,
    borderRadius: "4px",
  },
  buttonSecondary: {
   backgroundColor: BG_PRIMARY_GRAY,
   color: COLOR_PRIMARY_GRAY,
   borderRadius: "4px",
 },
  titleCard: {
    fontSize: "20px",
    fontWeight: 500,
    fontStyle: "normal",
    textAlign: "center",
    color: COLOR_COMMON_BLACK
  },
};
